import { getStorage } from '@/plugins/store';
export default {
  name: 'Footer',

  data() {
    return {
      links: [],
      footer: ''
    };
  },

  created() {
    this.getBaseSet();
  },

  methods: {
    async getBaseSet() {
      const res = getStorage('projectBaseData') || {};
      this.footer = res.copyright;
    }

  }
};